<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="true"
        class="ah-detail-dialog accounting-yearly-management-other-sheets-dialog"
        top="10vh"
        append-to-body
        :before-close="onBeforeClose"
        :lock-scroll="false"
        :close-on-click-modal="false"
        width="575px"
        @open="onOpen"
    >
        <template slot="title">
            <span>年度會計報表</span>
        </template>
        <div class="container">
            <h3>{{ year - 1911 }} 年度會計報表</h3>
            <table class="table-list" style="width: 100%;" cellspacing="0" cellpadding="0">
                <thead>
                    <tr>
                        <th>報表</th>
                        <th>檢視</th>
                        <th>來源頁面</th>
                        <th>下載</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style="width: 100%;">資產負債表</td>
                        <td><el-button size="mini" icon="el-icon-view" @click="$emit('onViewBalanceSheet', year)">檢視</el-button></td>
                        <td><el-button size="mini" icon="el-icon-link" @click="$router.push({ name: 'accounting-balance-sheet' })">連結</el-button></td>
                        <td><el-button size="mini" icon="el-icon-download" @click="downloadAccountBalanceSheet">Excel</el-button></td>
                    </tr>
                    <tr>
                        <td>綜合損益表</td>
                        <td><el-button size="mini" icon="el-icon-view" @click="$emit('onViewStatement', year)">檢視</el-button></td>
                        <td><el-button size="mini" icon="el-icon-link" @click="$router.push({ name: 'accounting-statement' })">連結</el-button></td>
                        <td><el-button size="mini" icon="el-icon-download" @click="downloadAccountingStatement">Excel</el-button></td>
                    </tr>
                    <tr>
                        <td>會計餘額試算表</td>
                        <td></td>
                        <td><el-button size="mini" icon="el-icon-link" @click="$router.push({ name: 'accounting-account-balance-spreadsheet' })">連結</el-button></td>
                        <td><el-button size="mini" icon="el-icon-download" @click="downloadAccountBalanceSpreadsheet">Excel</el-button></td>
                    </tr>
                    <tr>
                        <td>會計科目總分類帳</td>
                        <td></td>
                        <td><el-button size="mini" icon="el-icon-link" @click="$router.push({ name: 'accounting-general-ledger' })">連結</el-button></td>
                        <td><el-button size="mini" icon="el-icon-download" @click="downloadAccountingGeneralLedger">Excel</el-button></td>
                    </tr>
                    <tr>
                        <td>傳票明細（日記帳）</td>
                        <td></td>
                        <td><el-button size="mini" icon="el-icon-link" @click="$router.push({ name: 'accounting-voucher-list' })">連結</el-button></td>
                        <td><el-button size="mini" icon="el-icon-download" @click="downloadAccountingVoucherList">Excel</el-button></td>
                    </tr>
                    <tr>
                        <td>帳務匯總表</td>
                        <td></td>
                        <td><el-button size="mini" icon="el-icon-link" @click="$router.push({ name: 'accounting-summary' })">連結</el-button></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="button-container">
            <el-button icon="el-icon-download" @click="downloadAllExcels()">下載全部 Excel</el-button>
            <el-button class="cancel-btn" icon="el-icon-close" @click="$emit('close')">關閉</el-button>
        </div>
    </el-dialog>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import JSZip from 'jszip';
import { downloadExcel as downloadAccountBalanceSpreadsheetExcel } from '@/components/dashboard/Accounting/AccountingAccountBalanceSpreadsheet/exportExcelUtils';
import { downloadExcel as downloadAccountingGeneralLedgerExcel } from '@/components/dashboard/Accounting/AccountingGeneralLedger/exportExcelUtils';
import { downloadExcel as downloadAccountBalanceSpreadExcel } from '@/components/dashboard/Accounting/AccountingBalanceSheet/exportExcelUtils';
import { downloadNormalExcel as downloadAccountingStatementNormalExcel } from '@/components/dashboard/Accounting//AccountingStatement/exportExcelUtils';
import { downloadExcel as downloadAccountingVoucherListExcel } from '../AccountingVoucherList/exportExcelUtils';

export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        year: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
        };
    },
    computed: {
        companyName() {
            return this.$store.getters['menu/companyInfo'].cH_CMP;
        },
        startDate() {
            return moment().year(this.year).startOf('year').valueOf();
        },
        endDate() {
            return moment().year(this.year).endOf('year').valueOf();
        },
    },
    methods: {
        onOpen() {
        },
        async onBeforeClose() {
            this.$emit('close');
        },
        async downloadAccountBalanceSpreadsheet(directDownload = true) {
            return downloadAccountBalanceSpreadsheetExcel({ StartDate: this.startDate, EndDate: this.endDate }, this.companyName, null, directDownload);
        },
        async downloadAccountingGeneralLedger(directDownload = true) {
            return downloadAccountingGeneralLedgerExcel({ StartDate: this.startDate, EndDate: this.endDate }, this.companyName, null, directDownload);
        },
        async downloadAccountBalanceSheet(directDownload = true) {
            return downloadAccountBalanceSpreadExcel(this.endDate, this.companyName, directDownload);
        },
        async downloadAccountingStatement(directDownload = true) {
            return downloadAccountingStatementNormalExcel(this.startDate, this.endDate, this.companyName, null, true, directDownload);
        },
        async downloadAccountingVoucherList(directDownload = true) {
            return downloadAccountingVoucherListExcel({ StartDateStart: this.startDate, StartDateEnd: this.endDate }, this.companyName, null, directDownload);
        },
        async downloadAllExcels() {
            const zip = new JSZip();

            const { buffer: b1, fileName: f1 } = await this.downloadAccountBalanceSheet(false);
            zip.file(f1, b1);

            const { buffer: b2, fileName: f2 } = await this.downloadAccountingStatement(false);
            zip.file(f2, b2);

            const { buffer: b3, fileName: f3 } = await this.downloadAccountBalanceSpreadsheet(false);
            zip.file(f3, b3);

            const { buffer: b4, fileName: f4 } = await this.downloadAccountingGeneralLedger(false);
            zip.file(f4, b4);

            const { buffer: b5, fileName: f5 } = await this.downloadAccountingVoucherList(false);
            zip.file(f5, b5);


            // // 生成 ZIP 並下載
            zip.generateAsync({ type: 'Blob' }).then((content) => {
                const url = URL.createObjectURL(content);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${this.companyName} ${this.year} 年度會計報表.zip`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
        },
    },
};
</script>

<style lang="scss">
.accounting-yearly-management-other-sheets-dialog {
    h3 {
        font-size: 16pt;
        text-align: center;
        margin: 10px 0 40px 0;
    }
    .container {
        padding: 30px 50px 0;
        min-height: 150px;
    }
    .button-container {
        display: flex;
        justify-content: center;
        padding: 20px 0 40px;
    }
    .description {
        font-size: 12pt;
    }
    .table-list {
        margin-top: 25px;

        th, td {
            border-bottom: 1px solid #ddd;
            padding: 8px 5px;
            text-align: left;
            font-size: 11pt;
            color: #000;
        }
        th {
            font-size: 11pt;
            color: #888;
        }

        tr:hover {
            td {
                color: #463cb2;
            }
        }
    }
}
</style>
